import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../CSS/Login.css'
import CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
function Login() {
    const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const key = process.env.REACT_APP_FRONT_CODE;
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Check if form is already loading to prevent double submission
    try {
      const encryptedPassword = CryptoJS.AES.encrypt(password, key).toString();
      const response = await axios.post(`${apiUrl}/api/login`, { username, encryptedPassword });
      if (response.status === 205) {
        Swal.fire("Error", "Wrong username or password");
      }
      if (response.status === 204) {
        Swal.fire("Error", "This account has been deactivated");
      }
      if (response.status === 200) {
        const userData = response.data.user;
        if (!userData) {
          throw new Error('Invalid username or password');
        }
        // Store user data and role in localStorage
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('role', userData.UserType);
        switch (userData.UserType) {
          case 'Dispatcher':
            navigate("/dispatcher_home");
            break;
          case 'QualityInspector':
            navigate("/QA_home");
            break;
          case 'FrontDesk':
            navigate("/front_desk");
            break;
          case 'DataProcess':
            navigate("/admin/DataProcessing");
            break;
          default:
            navigate("/HomePage");
        }
      }
    } catch (error) {
      throw error;
    }
  };

  return (
    (<div className="login-container">
      <h2>{t('Login')}</h2>
      <form className="login-form" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">{t('Username:')}</label>
          <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} />
        </div>
        <div>
          <label htmlFor="password">{t('Password:')}</label>
          <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button type="submit">{t('Login')}</button>
        {/* <button type="button" onClick={handleRegisterClick}>Register</button> */}
        {error && <p className="error-message">{error}</p>}
      </form>
    </div>)
  );
}

export default Login;
